import Head from 'next/head';

import Post from 'src/views/Marketing/Blog/marketing/ebay-authenticity-guarantee';

export default function Example() {
  return (
    <>
      <Head>
        <title>Sell with confidence with eBay Authenticity Guarantee – and keep those fraud claims at bay!</title>
        <meta
          name='description'
          content='How does eBay guarantee the authenticity of premium items? With this free authentication program, you can validate your goods as the real deal if you sell sneakers, handbags, wallets, and trading cards.'
        />
        <link rel='canonical' href='https://tools.oneshop.com/blog/ebay-authenticity-guarantee' />
        <meta property='og:url' content='https://tools.oneshop.com/blog/ebay-authenticity-guarantee' />
        <meta
          property='og:title'
          content='Sell with confidence with eBay Authenticity Guarantee – and keep those fraud claims at bay!'
        />
        <meta
          property='og:description'
          content='How does eBay guarantee the authenticity of premium items? With this free authentication program, you can validate your goods as the real deal if you sell sneakers, handbags, wallets, and trading cards.'
        />
        <meta key='og-image' property='og:image' content='https://tools.oneshop.com/static/images/og-image.png?v=4' />
        <meta property='article:published_time' content='March 29th, 2022' />
        <meta property='article:modified_time' content='March 29th, 2022' />
        <meta property='article:tag' content='eBay' />
        <meta property='article:publisher' content='https://www.facebook.com/oneshopcompany' />
      </Head>
      <Post />
    </>
  );
}
